import React, { Fragment, useContext, useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import logo from '../../../images/logo1.png'
export function NavMenuToggle() {
	setTimeout(() => {
		let mainwrapper = document.querySelector("#main-wrapper");
		if (mainwrapper.classList.contains('menu-toggle')) {
			mainwrapper.classList.remove("menu-toggle");
		} else {
			mainwrapper.classList.add("menu-toggle");
		}
	}, 200);
}

const NavHader = () => {
	const [toggle, setToggle] = useState(false);
	const { navigationHader, openMenuToggle, background } = useContext(
		ThemeContext
	);


	const [isZoomed, setIsZoomed] = useState(false);
	const containerRef = useRef(null);

	
	useEffect(() => {
		const checkZoom = () => {
			const zoomLevel = window.innerWidth / window.outerWidth;
			const shouldZoomOut = zoomLevel <= 0.90;
			setIsZoomed(shouldZoomOut);

			
			if (shouldZoomOut) {
				document.body.classList.add('body-zoomed-out');
			} else {
				document.body.classList.remove('body-zoomed-out');
			}
		};

		window.addEventListener("resize", checkZoom);
		checkZoom();
		return () => window.removeEventListener("resize", checkZoom);
	}, []);




	return (
		<div className="nav-header">
			<Link
				to="/dashboard"
				className={`brand-logo ${isZoomed ? 'zoomed-out' : ''}`}
				ref={containerRef}
			>
				<img src={logo} alt="" className="img-fluid" style={{ width: 'clamp(25px, 5vw, 50px)', }} />
				<div className="brand-span mx-2">
					<span >
						
					</span>
					
				</div>

				
			</Link>
			
		</div>
	);
};

export default NavHader;
